// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__rPmqb","validationTips":"StatementDescriptor_validationTips__3zaQq"};